import React, { FunctionComponent } from 'react';
import classNames from 'classnames';
import sync from 'css-animation-sync';
import styles from './styles.module.scss';

// sync the loader animation to prevent the spinner from jumping when the page loads
sync(styles.spin);

interface Props {
  className?: string;
  variant?:
    | 'default'
    | 'fullscreen'
    | 'fill-container'
    | 'fill-container-overlay';
}

export const Spinner: FunctionComponent<Props> = ({ className, variant }) => {
  return (
    <div
      className={classNames(
        styles.loader,
        variant === 'fullscreen' && styles.fullscreen,
        variant === 'fill-container' && styles.fillContainer,
        ...(variant === 'fill-container-overlay'
          ? [styles.fillContainer, styles.withOverlay]
          : []),
        className,
      )}
    >
      <div />
    </div>
  );
};
